module.exports = __webpack_public_path__ + "static/img/phone-ecode-right.1b292e7f.jpg";